var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1756,
    height: 1828,
    viewBox: "0 0 1756 1828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.881 665.807c52.752 52.517 244.654 301.928 244.654 301.928L19.007 1037.16l182.645 31.15 89.671 11.75 458.904 55.97-20.066 30.61-137.64 218.93-199.635 283.17-90.71 143.48 76.667-61.37L913.2 1277.34l4.647 1.6 808.663 500.12-463.15-434.42-81.71-73.55-96.25-99.63 428.84 2.77h57.96l154.31-2.77-154.31-22.45-83.33-12.98-339.27-68.77 211.44-235.139L1679.8 501.97l-190.93 138.525S1342.16 742.8 1335.26 744.673l-224.39 141.585 137.56-678.604c1.79-21.617 26.44-177.157 26.44-177.157l-69.95 151.536-115.2 362.236-69.65 190.479-50.787 131.283-75.528-259.957L705.69-7.731l80.602 585.442 44.078 276.49-52.371-46.26S638.844 687.675 584.043 640.496C408.22 489.064 65.721 182.033 65.721 182.033s272.144 331.44 425.16 483.774",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1756v1828H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.31bdacee4ace5dc250c8550e6f7c6880.svg";
export { ForwardRef as ReactComponent };